import { useEffect } from "react";

const events = [
  "keypress",
  "scroll",
  "click",
  "touchmove",
  "touchstart",
  "touchend",
  "touchcancel",
  "wheel",
];

export const useActivityListener = (cb: () => void) => {
  useEffect(() => {
    cb();

    events.forEach((event) => {
      window.addEventListener(event, cb);
    });

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, cb);
      });
    };
  }, [cb]);
};
